import React, { useEffect, useState } from 'react';

import api from '../../services/api';

import { FiPlay } from 'react-icons/fi';

import { Container, MovieRating } from './styles';

import { IMoviesProps } from '../../interfaces/Movie';
import { Star } from 'phosphor-react';
import HetaryGroup from './HetaryGroup';

const CardMovieHighlight: React.FC = () => {

  const [currentMovie, setCurrentMovie] = useState<IMoviesProps>({} as IMoviesProps);

  useEffect(() => {
    (async () => {
      try {
        const response = await api.get(`/movies/suggestions/last`);
        setCurrentMovie(response.data);
      } catch (error) {
        console.log(error);
      }
    })();
  }, []);

  return (
      <Container to={`/sasaflix/${currentMovie?.id}`} cover={currentMovie?.cover}>
        <MovieRating>
          <aside>
            <Star size={20} weight="fill" />
            <p>{Number(String(currentMovie?.vote_average)).toFixed(1)}</p>
          </aside>
          <HetaryGroup age_group={currentMovie?.age_group} />
        </MovieRating>
        <main>
          <div>
            <FiPlay strokeWidth={2.5} size={24}  />
          </div>
          <footer>
            <h3>{currentMovie?.name}</h3>
          </footer>
        </main>
      </Container>
  );
}

export default CardMovieHighlight;
